"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SessionProvider = void 0;
const react_1 = __importDefault(require("react"));
const react_2 = require("next-auth/react");
const AuthGate_1 = require("../AuthGate");
const SessionProvider = ({ children, pageOptions, ...props }) => {
    const isPublicPage = pageOptions?.isPublic ?? false;
    return (react_1.default.createElement(react_2.SessionProvider, { ...props }, isPublicPage ? (children) : (react_1.default.createElement(AuthGate_1.AuthGate, { ...pageOptions }, children))));
};
exports.SessionProvider = SessionProvider;
